/* Piave · Reviews em video shoppable — modal player (reels) */
(function () {
  if (customElements.get('shoppable-reviews')) return;

  class ShoppableReviews extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.rv__thumb')).map(function (t) {
        return {
          video: t.dataset.video || '',
          poster: t.dataset.poster || '',
          purl: t.dataset.purl || '',
          pname: t.dataset.pname || '',
          pprice: t.dataset.pprice || '',
          pimg: t.dataset.pimg || '',
          shop: t.dataset.shop || 'Comprar'
        };
      });
      this.modal = this.querySelector('.rv__modal');
      this.videoEl = this.querySelector('.rv__video');
      this.i = 0;

      var self = this;
      this.querySelectorAll('.rv__thumb').forEach(function (t, idx) {
        t.addEventListener('click', function () { self.open(idx); });
      });
      this.modal.querySelector('.rv__close').addEventListener('click', this.close.bind(this));
      this.modal.querySelector('.rv__backdrop').addEventListener('click', this.close.bind(this));
      this.modal.querySelector('.rv__mute').addEventListener('click', this.toggleMute.bind(this));
      this.modal.querySelector('[data-dir="prev"]').addEventListener('click', function () { self.go(-1); });
      this.modal.querySelector('[data-dir="next"]').addEventListener('click', function () { self.go(1); });

      // vitrine lateral (carrossel dos thumbs)
      this.thumbsEl = this.querySelector('.rv__thumbs');
      this.aPrev = this.querySelector('.rv__arrow--prev');
      this.aNext = this.querySelector('.rv__arrow--next');
      if (this.thumbsEl && (this.aPrev || this.aNext)) {
        var step = function () { return Math.max(120, self.thumbsEl.clientWidth * 0.8); };
        this._updArrows = function () {
          var s = self.thumbsEl, max = s.scrollWidth - s.clientWidth - 2;
          if (max <= 0) { if (self.aPrev) self.aPrev.hidden = true; if (self.aNext) self.aNext.hidden = true; return; }
          if (self.aPrev) self.aPrev.hidden = s.scrollLeft <= 2;
          if (self.aNext) self.aNext.hidden = s.scrollLeft >= max;
        };
        if (this.aPrev) this.aPrev.addEventListener('click', function () { self.thumbsEl.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (this.aNext) this.aNext.addEventListener('click', function () { self.thumbsEl.scrollBy({ left: step(), behavior: 'smooth' }); });
        this.thumbsEl.addEventListener('scroll', this._updArrows, { passive: true });
        window.addEventListener('resize', this._updArrows);
        setTimeout(this._updArrows, 150);
      }

      document.addEventListener('keydown', function (e) {
        if (!self.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
      });
    }

    /* 10/09 (pedido do Lucas): o player docado a direita pode ser ARRASTADO de lado, para o
       meio ou de volta para o canto. So no computador: no celular ele ocupa a tela inteira.
       O arraste so comeca depois de 6px, para toque rapido em botao continuar sendo clique.
       A posicao fica guardada na visita (sessionStorage), como fracao da largura livre,
       para sobreviver a troca de video e a mudanca de tamanho da janela. */
    initDrag() {
      this._dragPronto = true;
      var self = this, modal = this.modal, dialog = modal.querySelector('.rv__dialog');
      var CHAVE = 'piave-rv-pos', inicio = null, arrastando = false;
      function podeArrastar() { return window.matchMedia('(min-width: 750px)').matches; }
      function limitar(x) { return Math.max(0, Math.min(window.innerWidth - modal.offsetWidth, x)); }
      this._aplicarPosicao = function () {
        var frac = NaN;
        if (podeArrastar()) { try { frac = parseFloat(sessionStorage.getItem(CHAVE)); } catch (e) {} }
        if (isNaN(frac)) { modal.style.left = ''; modal.style.right = ''; return; }
        modal.style.right = 'auto';
        modal.style.left = limitar(frac * (window.innerWidth - modal.offsetWidth)) + 'px';
      };
      dialog.addEventListener('pointerdown', function (e) {
        if (!podeArrastar() || e.button !== 0) return;
        if (e.target.closest('button, a, input, select, textarea')) return;
        inicio = { x: e.clientX, left: modal.getBoundingClientRect().left, id: e.pointerId };
        arrastando = false;
      });
      dialog.addEventListener('pointermove', function (e) {
        if (!inicio || e.pointerId !== inicio.id) return;
        var dx = e.clientX - inicio.x;
        if (!arrastando) {
          if (Math.abs(dx) < 6) return;
          arrastando = true;
          modal.classList.add('is-dragging');
          try { dialog.setPointerCapture(e.pointerId); } catch (err) {}
        }
        modal.style.right = 'auto';
        modal.style.left = limitar(inicio.left + dx) + 'px';
        e.preventDefault();
      });
      function soltar() {
        if (!inicio) return;
        if (arrastando) {
          modal.classList.remove('is-dragging');
          var livre = window.innerWidth - modal.offsetWidth;
          var frac = livre > 0 ? modal.getBoundingClientRect().left / livre : 1;
          try { sessionStorage.setItem(CHAVE, String(Math.round(frac * 1000) / 1000)); } catch (err) {}
        }
        inicio = null; arrastando = false;
      }
      dialog.addEventListener('pointerup', soltar);
      dialog.addEventListener('pointercancel', soltar);
      window.addEventListener('resize', function () { if (modal.classList.contains('is-open')) self._aplicarPosicao(); });
    }

    open(i) {
      this.i = i;
      this.render();
      this.modal.classList.add('is-open');
      if (!this._dragPronto) this.initDrag();
      this._aplicarPosicao();
      // NAO trava o scroll: player docado a direita, pagina continua rolavel (ref ColorWow)
      this.modal.setAttribute('aria-hidden', 'false');
    }
    close() {
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      if (this.videoEl) { this.videoEl.pause(); }
    }
    go(d) {
      var n = this.i + d;
      if (n < 0 || n >= this.items.length) return;
      this.i = n; this.render();
    }
    toggleMute() {
      if (!this.videoEl) return;
      this.videoEl.muted = !this.videoEl.muted;
      this.modal.querySelector('.rv__mute').dataset.muted = this.videoEl.muted ? '1' : '';
    }
    render() {
      var it = this.items[this.i];
      // video ou poster
      if (it.video) {
        this.videoEl.src = it.video;
        this.videoEl.poster = it.poster || '';
        this.videoEl.muted = false;
        this.videoEl.style.display = '';
        this.videoEl.play().catch(function () {});
      } else {
        this.videoEl.removeAttribute('src'); this.videoEl.load();
        this.videoEl.style.display = 'none';
        this.modal.querySelector('.rv__stage').style.backgroundImage = it.poster ? 'url(' + it.poster + ')' : '';
        this.modal.querySelector('.rv__stage').style.backgroundSize = 'cover';
        this.modal.querySelector('.rv__stage').style.backgroundPosition = 'center';
      }
      if (it.video) { this.modal.querySelector('.rv__stage').style.backgroundImage = ''; }
      // chip do produto
      var chip = this.modal.querySelector('.rv__chip');
      if (it.purl) {
        chip.style.display = '';
        chip.href = it.purl;
        chip.querySelector('.rv__chip-name').textContent = it.pname;
        chip.querySelector('.rv__chip-price').textContent = it.pprice;
        chip.querySelector('.rv__shop').textContent = it.shop;
        var img = chip.querySelector('img');
        if (it.pimg) { img.src = it.pimg; img.style.display = ''; } else { img.style.display = 'none'; }
      } else { chip.style.display = 'none'; }
      // nav enable/disable
      this.modal.querySelector('[data-dir="prev"]').disabled = this.i === 0;
      this.modal.querySelector('[data-dir="next"]').disabled = this.i === this.items.length - 1;
    }
  }
  customElements.define('shoppable-reviews', ShoppableReviews);
})();
